<template>
  <div id="app">
    <template v-if="appReady">
      <Navbar v-if="showNavbar" />
      <router-view />
    </template>
    <!-- Invisible loading state while permissions boot — no flash, no blank navbar -->
    <template v-else>
      <div style="visibility:hidden">
        <router-view />
      </div>
    </template>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Navbar from "@/components/Navbar.vue";
import { initPermissions, clearPermissions } from "@/utils/permissions";

export default {
  components: { Navbar },
  setup() {
    const route  = useRoute();
    const router = useRouter();
    const appReady = ref(false);

    const showNavbar = computed(() => {
      if (route.meta?.hideNavbar) return false;
      if (route.name === "Login") return false;
      return true;
    });

    onMounted(async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        // Not logged in — clear any stale perm cache, go to login
        clearPermissions();
        appReady.value = true;
        return;
      }

      // Logged in — load permissions before showing anything
      try {
        await initPermissions(false);
      } catch (e) {
        // Token expired / invalid — clear everything, redirect to login
        clearPermissions();
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("user_id");
        localStorage.removeItem("user_name");
        const slug = localStorage.getItem("company_id");
        appReady.value = true;
        router.replace(slug ? `/login/${slug}` : "/not-found");
        return;
      }

      appReady.value = true;
    });

    return { showNavbar, appReady };
  },
};
</script>
